import { buildDeleteFeedbackPayload } from './buildDeleteFeedbackPayload.js';
import { assertFeedbackContract } from './feedbackContract.js';

export async function submitDeleteFeedback({
  soulodyApi,
  store,
  isMobileApp,
  platformId,
  profileId,
  handleError
}) {
  if (!(await store.dispatch('soulodyApi/ensureValidToken'))) return false;

  const payload = buildDeleteFeedbackPayload({
    isMobileApp,
    platformId,
    feedbackReasons: store.getters['profile/accountDelete/feedbackReasons'],
    feedbackDetails: store.getters['profile/accountDelete/feedbackDetails'],
    profileId
  });

  assertFeedbackContract(payload);

  try {
    await soulodyApi.post('user-feedback', payload);
    return true;
  } catch (err) {
    handleError({ error: err, code: '0x00000069' });
    return false;
  }
}
